import { useState } from 'react';
import { RiDownload2Line, RiLoader4Line } from 'react-icons/ri';

import { getGenerationMusicDownloadUrl } from '@/music/api';
import type { Music } from '@/music/types';

interface DownloadButtonProps {
  music: Music;
}

export const DownloadButton = ({ music }: DownloadButtonProps) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      const downloadUrl =
        music.source === 'generation'
          ? await getGenerationMusicDownloadUrl(music.id)
          : (music.audios.find((a) => a.type === 'full') ?? music.audios[0]).url;
      const fileFormat = new URL(downloadUrl).pathname.split('.').at(-1);

      const response = await fetch(downloadUrl);
      if (!response.ok) {
        throw new Error('음원 다운로드에 실패했습니다.');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${music.id}.${fileFormat}`;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('음원 다운로드 중 오류 발생:', err);
      alert('음원 다운로드에 실패했습니다.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <button
      onClick={handleDownload}
      disabled={isDownloading}
      aria-label="다운로드"
      title="다운로드"
      className="text-muted-foreground hover:bg-accent hover:text-foreground flex size-9 shrink-0 items-center justify-center rounded-lg transition-colors disabled:cursor-not-allowed disabled:opacity-50"
    >
      {isDownloading ? (
        <RiLoader4Line className="animate-spin text-lg" />
      ) : (
        <RiDownload2Line className="text-lg" />
      )}
    </button>
  );
};
